import jQuery from 'jquery';
import Const from 'constants';

const Modal = {
    openModal(component) {
        jQuery('body').addClass('modal-open');
        return {
            type: Const.OPEN_MODAL,
            data: {
                component,
                open: true,
            },
        };
    },
    closeModal() {
        jQuery('body').removeClass('modal-open');
        return {
            type: Const.CLOSE_MODAL,
            data: {
                component: '',
                open: false,
            },
        };
    },
};

export default Modal;
